<script lang="ts">
    import { get } from "svelte/store";
    import { Options } from "../../../shared/wspayload";
    import { messageInfo } from "../store";
    import Input from "../components/Input.svelte";
    import Radio from "../components/Radio.svelte";
    import Divider from "../components/Divider.svelte";
    import Submit from "../components/Submit.svelte";
    import Groupcheck from "../components/Groupcheck.svelte";

    const PLACES = [
        "Tableau de bord à gauche",
        "Tableau de bord au centre",
        "Tableau de bord à droite",
    ];

    const info = get(messageInfo);
    if (info.installation && !PLACES.includes(info.installation))
        PLACES.push(info.installation);
    else PLACES.push("Ailleurs");

    const OPTIONS: [string, number][] = [
        ["Avec bouton vie privée", Options.privacy],
        ["Avec bouton vie privée LED", Options.privacyLed],
        ["Avec badge d'identification", Options.badge],
        ["Avec capteur de température", Options.temperature],
    ];
</script>

<main>

    <Divider>Boitier</Divider>
    <Input
        bind:value={$messageInfo.imei}
        helper="Etiquette blanche sur face avant"
        minlength="15"
        maxlength="15"
    >
        15 chiffres IMEI
    </Input>

    <Divider>Monteur</Divider>
    <Input
        bind:value= {$messageInfo.fitterLastName}
        helper="Votre nom"
    >
     Nom
    </Input>

    <Input
        bind:value= {$messageInfo.company}
        helper="Votre société"
    >
      Société
    </Input>


    <Divider>Emplacement du boîtier</Divider>
    {#each PLACES as place, i}
        <Radio
            bind:group={$messageInfo.installation}
            value={place}
            name="places"
            otherInput={i == PLACES.length - 1 ? true : false}
        />
    {/each}

    <Divider>Options</Divider>
    <Groupcheck bind:group={$messageInfo.options} values={OPTIONS} />

    <Submit backButton>Valider</Submit>
</main>